import { render } from "./FacturacionPagosPage.vue?vue&type=template&id=89d86b94"
import script from "./FacturacionPagosPage.vue?vue&type=script&lang=js"
export * from "./FacturacionPagosPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__